import { render, staticRenderFns } from "./ChangeBoardOwnerModal.vue?vue&type=template&id=49a0d2d1"
import script from "./ChangeBoardOwnerModal.vue?vue&type=script&lang=ts"
export * from "./ChangeBoardOwnerModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports